import { render, staticRenderFns } from "./SrModalPageForm.vue?vue&type=template&id=cf89d904"
import script from "./SrModalPageForm.vue?vue&type=script&lang=js"
export * from "./SrModalPageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports